module.exports = __webpack_public_path__ + "media/images/default/pages/public_sciences/Frame176-62dcfe4d1d9de7899a3e096586202705.png";